// src/backendServices/liveStreamManagment/api_xtreamCode.ts

import { WWW_URLS } from '../urls';
import axios from 'axios';

import { BackendResponse } from '../../dataTypes/backendServicesManagment/types';
import {
  XtreamCredentials,
  XtreamLiveStream,
} from '../../dataTypes/liveStreamManagment/types_xtreamCode';

export interface BackendResponse_XtreamLiveStreams
  extends BackendResponse<XtreamLiveStream[]> {}

// ── Helper : normalise un serveur en HTTPS ────────────────────────────────────

function normalizeServer(server: string): string {
  const trimmed = server.replace(/\/$/, '');
  if (/^http:\/\//i.test(trimmed))  return trimmed.replace(/^http:\/\//i, 'https://');
  if (/^https:\/\//i.test(trimmed)) return trimmed;
  return `https://${trimmed}`;
}

// ── Helper : force une URL quelconque en HTTPS ────────────────────────────────


// ─────────────────────────────────────────────────────────────────────────────

/**
 * Récupère la liste des flux live depuis un serveur Xtream Codes.
 * Endpoint : GET https://SERVER/player_api.php?username=USER&password=PASS&action=get_live_streams
 */
export const getLiveStreams = async (
  credentials: XtreamCredentials
): Promise<BackendResponse_XtreamLiveStreams> => {
  const { server, username, password } = credentials;

  const base = normalizeServer(server);
  const url  = `${base}/player_api.php?username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}&action=get_live_streams`;

  console.log ('getLiveStreams', credentials, url)

  try {
    const response = await axios.get(url);

    console.log ('getLiveStreams', response)

    if (response.status === 200 && Array.isArray(response.data)) {
      const streams: XtreamLiveStream[] = (response.data as any[]).map((item) => ({
        stream_id  : item.stream_id   ?? 0,
        name       : item.name        ?? '',
        stream_icon: item.stream_icon ?? '',
        category_id: item.category_id ?? '',
      }));

      return {
        code   : 1,
        comment: 'Récupération des flux live réussie.',
        payload: streams,
      };
    }

    return {
      code   : -1,
      comment: 'Réponse inattendue du serveur Xtream.',
      payload: [],
    };
  } catch (err) {
    if (axios.isAxiosError(err)) {
      return {
        code   : -101,
        comment: err.message,
        payload: [],
      };
    }
    return {
      code   : -102,
      comment: 'Erreur inconnue',
      payload: [],
    };
  }
};

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Construit l'URL m3u8 d'un flux live Xtream Codes (avant résolution des redirections).
 * Format : https://SERVER/live/USER/PASS/STREAM_ID.m3u8
 */
export const buildLiveStreamUrl = (
  credentials: XtreamCredentials,
  streamId   : number
): string => {
  const base = credentials.server;
  return `${base}/live/${encodeURIComponent(credentials.username)}/${encodeURIComponent(credentials.password)}/${streamId}.m3u8`;
};

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Enveloppe une URL de média dans le proxy nginx — mais seulement quand il le faut.
 *
 * Le proxy n'existe que pour le mixed-content : une page servie en HTTPS ne peut
 * pas charger un manifest en HTTP clair, le navigateur bloque. Une cible déjà en
 * HTTPS, il la joint directement — et le proxy, lui, la refuse : il n'accepte que
 * des cibles `http://` et répond 400 sur les autres. L'envelopper serait donc
 * doublement faux : inutile, et fatal.
 *
 * C'est la même règle que suit déjà le ProxyLoader de HlsAcquirer pour les
 * segments d'une playlist ; elle vaut maintenant aussi pour le manifest.
 */
export const toProxiedUrl = (
  url      : string,
  proxyBase: string = WWW_URLS.broadcastingServer,
): string =>
  /^https:\/\//i.test(url)
    ? url
    : `${proxyBase.replace(/\/$/, '')}/http-proxy?url=${url}`;

/**
 * Résout l'URL finale d'un flux live Xtream en suivant les redirections 302.
 
 */

export const resolveLiveStreamUrl = (
  credentials: XtreamCredentials,
  streamId   : number
): string => {
  const originalUrl = buildLiveStreamUrl(credentials, streamId);
  
  console.log ('resolveLiveStreamUrl', credentials, streamId, originalUrl)
  
  return toProxiedUrl(originalUrl);
};